/* global wpApiSettings */

import formMessage from './form-message.js';

let $form;

function init() {

	$form = $('.form--password');

	if (!$form.length) {
		return;
	}

	$form.on('submit', (event) => {
		event.preventDefault();
		handleFormSubmit(event);
	});

}

function handleFormSubmit(event) {

	const formData = new FormData($form.get(0));

	let $formSubmit = $form.find('button[type="submit"]');
	let itemType = $form.data('itemType');

	$formSubmit.prop('disabled', true).addClass('is--loading');

	$.ajax({
		url: $form.attr('action'),
		method: 'POST',
		processData: false,
		contentType: false,
		dataType: 'json', // TODO: Check why this endpoint doesn't send the response correctly
		beforeSend: (xhr) => {
			xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
		},
		data: formData
	})
	.done((data, textStatus, jqXHR) => {

		if (jqXHR.status === 200) {
			document.location = (itemType === 'password-reset') ? './?action=success' : './?action=checkemail';
		} else {
			console.warn(data, textStatus);
		}

		$formSubmit.prop('disabled', false).removeClass('is--loading');

	})
	.fail((jqXHR, textStatus, errorThrown) => {

		if (jqXHR.responseJSON.code === 'invalidcombo') {
			formMessage.handleEverything($form, 'Käyttäjätunnus tai sähköpostiosoite ei kelpaa.', 'error');
		} else {
			formMessage.handleEverything($form, jqXHR.responseJSON.message, 'error');
		}

		$formSubmit.prop('disabled', false).removeClass('is--loading');

	});

}

export default {
	init
};
